<script setup>
  import { ref, computed, onMounted } from "vue";

const props = defineProps({
  msg: {
    type: Object,
    required: true,
  },
});

const displayTxt = ref("");
const typingDone = ref(false);

/**
 * Detect SOP format
 */
const isSOP = computed(() => {
  if (!props.msg?.text) return false;
  const lines = props.msg.text.split("\n").filter(Boolean);
  return lines.length > 1 && /^\d+\./.test(lines[1]);
});

/**
 * Final formatted HTML (only after typing)
 */
const formattedMessage = computed(() => {
  if (!typingDone.value) {
    return `<p style="margin:0;" class="p">${displayTxt.value}</p>`;
  }

  if (!isSOP.value) {
    return `<p style="margin:0;" class="p">${props.msg.text}</p>`;
  }

  const lines = props.msg.text.split("\n").map(l => l.trim()).filter(Boolean);
  const title = lines[0];
  const steps = lines.slice(1);

  return `
    <div styele="display: flex; flex-direction: column; gap: 8px;">
      <div style="font-weight: 600;color: #111827;margin-bottom: 4px;">${title}</div>
      <ol style="padding-left: 16px; margin: 0; color: #374151; ">
        ${steps.map(step => `<li style="margin-bottom: 4px;">${step.replace(/^\d+\.\s*/, '')}</li>`).join('')}
      </ol>
    </div>
  `;
});

/**
 * Typing effect
 */
onMounted(() => {
  if (props.msg?.sender !== "bot") {
    displayTxt.value = props.msg.text;
    typingDone.value = true;
    return;
  }

  let i = 0;
  const fullText = props.msg.text;

  const interval = setInterval(() => {
    displayTxt.value += fullText[i];
    i++;

    if (i >= fullText.length) {
      clearInterval(interval);
      typingDone.value = true;
    }
  }, 25); // typing speed (lower = faster)
});


</script>

<template>
  <div
    class="message-row"
    :class="msg?.sender === 'user' ? 'align-right' : 'align-left'"
  >
    <!-- Bot Avatar -->
    <div v-if="msg?.sender === 'bot'" class="avatar bot-avatar">
      <img src="/ats_chat.png" alt="" srcset="">
    </div>

    <!-- Message Bubble -->
    <div
      class="bubble akkurate-extra-small"
      :class="msg?.sender === 'user' ? 'user-bubble' : 'bot-bubble'"
    >
      <div v-html="formattedMessage"></div>

      <!-- Score -->
      <!-- <span
        v-if="
          msg?.score !== undefined && msg?.text?.length === displayTxt?.length
        "
        class="score"
      >
        ({{ msg?.score?.toFixed(2) }})
      </span> -->

      <!-- Feedback Buttons -->
      <!-- <div
        v-if="
          msg?.sender === 'bot' &&
          !msg?.feedback &&
          msg?.text?.length === displayTxt?.length
        "
        class="feedback-buttons"
      >
        <button class="btn helpful" @click="handleFeedback(msg?.id, 'helpful')">
          ✅ Helpful
        </button>

        <button
          class="btn not-helpful"
          @click="handleFeedback(msg?.id, 'not_helpful')"
        >
          ❌ Not Helpful
        </button>
      </div> -->

      <!-- Feedback Result -->
      <!-- <p v-if="msg?.feedback" class="feedback-text">
        Feedback:
        {{ msg?.feedback === "helpful" ? "✅ Helpful" : "❌ Not Helpful" }}
      </p> -->
    </div>

    <!-- User Avatar -->
    <div v-if="msg?.sender === 'user'" class="avatar user-avatar">👤</div>
  </div>
</template>

<style scoped>
/* Layout */
.message-row {
  display: flex;
  margin-bottom: 12px;
}

.align-right {
  justify-content: flex-end;
}

.align-left {
  justify-content: flex-start;
}

/* Avatars */
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.bot-avatar {
  margin-right: 8px;
  background-color: #fff;
}

.bot-avatar img {
  width: 85%;
}

.user-avatar {
  margin-left: 8px;
  background-color: #22c55e;
}

/* Message Bubbles */
.bubble {
  max-width: 75%;
  padding: 8px;
  border-radius: 16px;
  word-wrap: break-word;
  line-height: 1rem !important;
  text-align: left !important;
}

.user-bubble {
  background-color: #22c55e;
  color: white;
  border-bottom-right-radius: 0;
}


/* Score */
.score {
  margin-left: 8px;
  font-size: 12px;
  font-style: italic;
  opacity: 0.8;
}

/* Feedback */
.feedback-buttons {
  margin-top: 8px;
  display: flex;
  gap: 8px;
}

.btn {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  color: white;
  cursor: pointer;
  border: none;
}

.helpful {
  background-color: #4ade80;
}

.helpful:hover {
  background-color: #22c55e;
}

.not-helpful {
  background-color: #f87171;
}

.not-helpful:hover {
  background-color: #ef4444;
}

.feedback-text {
  margin-top: 4px;
  font-size: 12px;
  font-style: italic;
  color: #4b5563;
}

.bot-bubble {
  background-color: #f3f4f6;
  color: #111827;
  border-bottom-left-radius: 0;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

</style>
